import { useMemo } from 'react';
import uniqueId from 'lodash/uniqueId';

const useUniqueId = (prefix?: string): string =>
  useMemo(() => uniqueId(prefix ? `${prefix}-` : undefined), [prefix]);

export default useUniqueId;
